export default __webpack_public_path__ + "45d1a2e28c650ec41444dc10846d9000.jpg";